import {ActionType, reducerStoreType, settlementsStateType} from "./types";

const defaultState = {
    filters: {
        startDate: '',
        endDate: '',
    },
    list: [],
    total: 0,
    currentPage: 1,
    recordsPerPage: 20,
}


const settlements = (state:settlementsStateType = defaultState, action: ActionType<any>) => {
    switch (action.type) {
        case 'SET_SETTLEMENTS':
            return {
                ...state,
                ...action.payload.data,
                ...action.payload.pageParams
            }
        case 'SETTLEMENT_FILTER_CHANGE':
            return {
                ...state,
                filters: {...action.payload},
            }
        case 'CLEAR_SETTLEMENT_FILTER':
            return {
                ...state,
                filters: {
                    startDate: '',
                    endDate: '',
                },
            }
        case 'INIT_RECORDS_PER_PAGE':
            return {
                ...state,
                recordsPerPage: action.payload.recordsPerPage
            }
        case 'LOGOUT':
            return {
                ...state,
                filters: {
                    startDate: '',
                    endDate: '',
                }
            }
        default:
            return state;
    }
}
export const getSettlementsPageParam = (state: reducerStoreType) => {
    return {
        currentPage: state.settlements.currentPage,
        recordsPerPage: state.settlements.recordsPerPage
    }
}
export const getFilters = (state:reducerStoreType) =>{
    return state.settlements.filters
}


export default settlements